(function (Drupal) {
  'use strict';
  Drupal.behaviors.rinok = {
    attach: function(context, settings) {
      const dropdown = document.querySelectorAll('.dropdown');
      const dropdownToggle = document.querySelectorAll('.dropdown-toggle');
      const dropdownMenu = document.querySelectorAll('.dropdown-menu');
      const showClass = 'show';

      function handleDropdownHover(event) {
        const dropdownItem = event.currentTarget;
        const dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');
        const dropdownMenu = dropdownItem.querySelector('.dropdown-menu');

        if (event.type === 'mouseenter') {
          dropdownItem.classList.add(showClass);
          dropdownToggle.classList.add(showClass);
          dropdownToggle.setAttribute('aria-expanded', 'true');
          dropdownToggle.setAttribute('aria-haspopup', 'true');
          dropdownToggle.setAttribute('data-bs-toggle', 'dropdown-click');
          dropdownMenu.setAttribute('data-bs-popper', 'none');
          dropdownMenu.classList.add(showClass);
        } else if (event.type === 'mouseleave') {
          dropdownItem.classList.remove(showClass);
          dropdownToggle.classList.remove(showClass);
          dropdownToggle.setAttribute('aria-expanded', 'false');
          dropdownToggle.setAttribute('aria-haspopup', 'false');
          dropdownToggle.setAttribute('data-bs-toggle', 'dropdown');
          dropdownMenu.setAttribute('data-bs-popper', 'none');
          dropdownMenu.classList.remove(showClass);
        }
      }

      function handleWindowResize() {
        if (window.matchMedia('(min-width: 1200px)').matches) {
          dropdown.forEach(function(item) {
            item.addEventListener('mouseenter', handleDropdownHover);
            item.addEventListener('mouseleave', handleDropdownHover);
          });
        } else {
          dropdown.forEach(function(item) {
            item.removeEventListener('mouseenter', handleDropdownHover);
            item.removeEventListener('mouseleave', handleDropdownHover);
          });
        }
      }

      window.addEventListener('load', handleWindowResize);
      window.addEventListener('resize', handleWindowResize);

      var style = document.getElementById('injected-style');
      if (style) {
        style.parentNode.removeChild(style);
      }

    }
  };

  document.addEventListener("DOMContentLoaded", function() {
    let paragraphs = document.querySelectorAll('p');
    paragraphs.forEach(function(paragraph) {
      if (paragraph.innerHTML.trim() === '&nbsp;') {
        paragraph.style.display = 'none';
      }
    });
  });

  let prevScrollPos = window.pageYOffset;
  const header = document.querySelector("header");

  window.addEventListener('DOMContentLoaded', function() {
    let currentScrollPos = window.pageYOffset;
    const hasClass = document.body.classList.contains("gin--horizontal-toolbar");
    if (hasClass) {
      header.style.top = "112px";
      header.classList.add('header-admin');
    } else {
      header.style.top = "0";
      header.classList.add('header-top');
    }
  });

  window.addEventListener('scroll', function() {
    let currentScrollPos = window.pageYOffset;
    const hasClass = document.body.classList.contains("gin--horizontal-toolbar");
    if (prevScrollPos > currentScrollPos) {
      // Показываем заголовок при прокрутке вверх
      if (hasClass && currentScrollPos > 135) {
        header.style.top = "53px";
      } else {
        header.style.top = "0";
        header.classList.remove('header-top');
      }
    } else {
      // Скрываем заголовок при прокрутке вниз
      if (hasClass && currentScrollPos > 135) {
        header.style.top = "-23px";
        header.classList.remove('header-admin');
      } else if (currentScrollPos > 75) {
        header.style.top = "-75px";
        header.classList.remove('header-top');
      }
    }
    if (currentScrollPos < 113 && hasClass) {
      // Показываем заголовок, когда страница достигает верхней части
      header.style.top = "112px";
      header.classList.add('header-admin');
    } else if (currentScrollPos === 0) {
      // Показываем заголовок, когда страница достигает верхней части
      header.style.top = "0";
      header.classList.add('header-top');
    }
    prevScrollPos = currentScrollPos;
  });
})(Drupal);
